// removed by extract-text-webpack-plugin
module.exports = {"root":"ZTV9_16","link":"_117xZqt","label":"_3l6bDqT","labelOutline":"_-CLfGZn","chevronSvg":"UwM6V9N"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Search/components/SearchBar/components/MoreOptions/MoreOptions.less
 ** module id = 906
 ** module chunks = 0
 **/